<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="subject"
                rules="required"
              >
                <TextInput
                  v-model="form.subject"
                  :label="$t('subject')"
                  :tooltipMessage="$t('subject')"
                  :required="true"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="language"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("language") }}&nbsp;<span style="color: red">*</span>
                </label>
                <div class="form-group">
                  <multiselect
                    style="z-index: 9999"
                    v-model="form.language"
                    :options="['english', 'french', 'german', 'spanish']"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors, validate }"
                name="thumbnail"
                :rules="{ required: form.isHighlight }"
                class="d-flex flex-column"
              >
                <label class="input-label form-label"
                  >{{ $t("thumbnail") }}&nbsp;<span
                    v-show="form.isHighlight"
                    style="color: red"
                    >*</span
                  >
                </label>
                <input
                  type="file"
                  @change="
                    (event) => {
                      addFile(event, 'thumbnail');
                      validate();
                    }
                  "
                  @input="validate"
                  accept="image/*"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group d-flex flex-column">
                <label class="form-label">{{ $t("image") }} </label>
                <input
                  type="file"
                  @change="addFile($event, 'image')"
                  accept="image/*"
                />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Short Description"
                :rules="{ required: form.isHighlight }"
              >
                <TextInput
                  v-model="form.shortDescription"
                  :label="$t('shortDescription')"
                  :tooltipMessage="$t('shortDescription')"
                  :required="form.isHighlight"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label" for="cars">{{
                $t("highlight")
              }}</label>

              <input
                id="active"
                class="form-check-input-custom ml-2"
                v-model="form.isHighlight"
                type="checkbox"
              />
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("description") }}&nbsp;<span style="color: red"
                    >*</span
                  >
                </label>
                <vue-editor
                  :editorOptions="editorOptions"
                  v-model="form.description"
                ></vue-editor>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-2">
        <router-link
          to="/news"
          class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12" />
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <b-button
          variant="primary"
          @click="createNews"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
          v-if="$can(`${$route.meta.permission}.create`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("createNews") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import { VueEditor } from "vue2-editor";
import "quill/dist/quill.snow.css";
import Multiselect from "vue-multiselect";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import { required, email } from "@validations";

export default {
  components: {
    TextInput,
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
    VueEditor,
  },
  mixins: [fileHandlerMixin, formDirtyMixin],
  computed: {
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("news"),
          to: "/news",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.subject ||
        !this.form.language ||
        !this.form.description ||
        (this.form.isHighlight && !this.form.thumbnailImage) ||
        (this.form.isHighlight && !this.form.shortDescription)
      );
    },
  },
  mounted() {
    this.originalForm = JSON.stringify(this.form);
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ size: ["small", false, "large", "huge"] }],

            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],

            [{ direction: "rtl" }],
            [{ align: [] }],

            [{ color: [] }, { background: [] }],

            ["link", "image", "video"],

            ["clean"],
          ],
        },
      },
      originalForm: null,
      form: {
        subject: "",
        description: "",
        language: "english",
        shortDescription: "",
        isHighlight: false,
        thumbnailImage: {},
        file: {},
      },
      thumbnail: {},
      image: {},
    };
  },
  methods: {
    async createNews() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          if (
            this.form.description.match(/^(<p><br><\/p>)+$/) ||
            this.form.description.replace(/\s+/g, "") == "<p></p>"
          ) {
            this.$refs.simpleRules.setErrors({
              Description: [this.$t("theDescriptionFieldIsRequired")],
            });
            return;
          }
          try {
            this.$store.commit("showLoader", true);
            if (this.form.thumbnailImage instanceof File) {
              const response = await this.handleFileUpload(
                this.form.thumbnailImage
              );
              if (!response?.data[0]?.id) {
                this.$store.commit("showLoader", false);
              } else {
                this.thumbnail = {
                  id: response?.data[0]?.id,
                  name: response?.data[0]?.originalFileName,
                  extension: response?.data[0]?.type,
                };
              }
            }
            if (this.form.file instanceof File) {
              const response2 = await this.handleFileUpload(this.form.file);
              if (!response2?.data[0]?.id) {
                this.$store.commit("showLoader", false);
              } else {
                this.image = {
                  id: response2?.data[0]?.id,
                  name: response2?.data[0]?.originalFileName,
                  extension: response2?.data[0]?.type,
                };
              }
            }
            await this.$store.dispatch("news/create", {
              ...this.form,
              thumbnailImage: this.thumbnail,
              file: this.image,
            });
            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            this.$router.push("/news");
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
    addFile(event, type) {
      const file = event.target.files[0];
      if (type === "thumbnail") this.form.thumbnailImage = file;
      else this.form.file = file;
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
